"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _localityState = _interopRequireDefault(require("./locality-state"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var LocalityCommonRegion = {
  CANBERRA: {
    regionId: 391,
    name: 'Canberra',
    state: _localityState.default.ACT,
    slug: 'canberra-act'
  },
  QUEANBEYAN: {
    regionId: 557,
    name: 'Queanbeyan Region',
    state: _localityState.default.NSW,
    slug: 'queanbeyan-region-nsw'
  },
  SOUTHERN_TABLELANDS: {
    regionId: 537,
    name: 'Southern Tablelands',
    state: _localityState.default.NSW,
    slug: 'southern-tablelands-nsw'
  }
};
var _default = exports.default = LocalityCommonRegion;